<template>
  <div class="control" @click="toggleMode"  v-tooltip.left="{content: mode === 'normal'? 'Pause':'Play'}">
    <img v-if="mode === 'normal'" src="../../assets/icon_pause.svg" style="height: 23px;">
    <img v-if="mode === 'timeslice'" src="../../assets/icon_play.svg" style="height: 23px;">
  </div>
</template>

<script>
  export default {
    name: 'TimeSliceControl',
    props: {
      mode: {
        type: String
      }
    },

    methods: {
      toggleMode() {
        if(this.mode === 'normal') {
          this.$emit('updateMode', 'timeslice')
        } else {
          this.$emit('updateMode', 'normal')
        }
      }
    }
  }
</script>

<style scoped>

</style>
